//      
import {
  getBox,
  withScroll,
  createBox,
  expand,
                
                
               
} from 'css-box-model';
import getDroppableDimension, {
               
} from '../../state/droppable/get-droppable';
                                     
             
                     
                      
            
             
                     
import getScroll from './get-scroll';

const getClient = (
  targetRef             ,
  closestScrollable          ,
)           => {
  const base           = getBox(targetRef);

  // Droppable has no scroll parent
  if (!closestScrollable) {
    return base;
  }

  // Droppable is not the same as the closest scrollable
  if (targetRef !== closestScrollable) {
    return base;
  }

  // Droppable is scrollable

  // Element.getBoundingClient() returns a clipped padding box:
  // When not scrollable: the full size of the element
  // When scrollable: the visible size of the element
  // (which is not the full width of its scrollable content)
  // So we recalculate the borderBox of a scrollable droppable to give
  // it its full dimensions. This will be cut to the correct size by the frame

  // Creating the paddingBox based on scrollWidth / scrollTop
  // scrollWidth / scrollHeight are based on the paddingBox of an element
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight
  const top         = base.paddingBox.top - closestScrollable.scrollTop;
  const left         = base.paddingBox.left - closestScrollable.scrollLeft;
  const bottom         = top + closestScrollable.scrollHeight;
  const right         = left + closestScrollable.scrollWidth;

  // unclipped padding box
  const paddingBox          = {
    top,
    right,
    bottom,
    left,
  };

  // Creating the borderBox by adding the borders to the paddingBox
  const borderBox          = expand(paddingBox, base.border);

  // We are not accounting for scrollbars
  // Adjusting for scrollbars is hard because:
  // - they are different between browsers
  // - scrollbars can be activated and removed during a drag
  // We instead account for this slightly in our auto scroller

  const client           = createBox({
    borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding,
  });
  return client;
};

              
                   
                                  
           
                         
                       
                          
                            
                             
   

export default ({
  ref,
  descriptor,
  env,
  windowScroll,
  direction,
  isDropDisabled,
  isCombineEnabled,
  shouldClipSubject,
}      )                     => {
  const closestScrollable           = env.closestScrollable;
  const client           = getClient(ref, closestScrollable);
  const page           = withScroll(client, windowScroll);

  const closest           = (() => {
    if (!closestScrollable) {
      return null;
    }

    const frameClient           = getBox(closestScrollable);
    const scrollSize             = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth,
    };

    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll(closestScrollable),
      scrollSize,
      shouldClipSubject,
    };
  })();

  const dimension                     = getDroppableDimension({
    descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction,
    client,
    page,
    closest,
  });

  return dimension;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-droppable-publisher/get-dimension.js